import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {accessorialsPricingType} from "../../types/accessorialsPricing.type";

export class PricePlanPricingViewCtrl implements IController {

  program: any;
  groups: any;
  programId: any;
  accountId: any;

  public isSaveAvailable: any;
  public groupKeys: any;
  public groupKeysCopy: any;
  public accessorials?: any;
  public accessorialPriceTypes?: any;
  public spotDimensions: any;


  /* @ngInject */
  constructor(private PricePlanService) {
  }

  $onInit() {
    this._initValues();
  }

  private _initValues(){
    this.isSaveAvailable = false;
    this.groupKeys = this.PricePlanService.generatePreferencesDataGroupKeys(this.program.data);
    this.groupKeysCopy = angular.copy(this.groupKeys);

    if (this.groupKeysCopy.SpotDimensions) {
      this.spotDimensions = angular.copy(this.groupKeys.SpotDimensions);

      if (!this.spotDimensions.SpotDimensions.value) {
        this.spotDimensions.SpotDimensions.value = {}
      }
    }

    if (this.groupKeysCopy.Accessorials) {
      this.accessorialPriceTypes = accessorialsPricingType;
      this.accessorials = angular.copy(this.groupKeys.Accessorials);

      if (!this.accessorials.AccessorialAppointment.value) {
        this.accessorials.AccessorialAppointment.value = {}
      }
      if (!this.accessorials.AccessorialFuel.value) {
        this.accessorials.AccessorialFuel.value = {}
      }
      if (!this.accessorials.AccessorialObligate.value) {
        this.accessorials.AccessorialObligate.value = {}
      }
    }
  }

  onDataChange() {
    this.isSaveAvailable = !_.isEqual(this.groupKeys, this.groupKeysCopy);
  }

  onChangeAccessorial() {
    const accessorialsCopy = angular.copy(this.accessorials);
    if (_.isEmpty(accessorialsCopy.AccessorialAppointment.value)) {
      _.unset(accessorialsCopy, 'AccessorialAppointment.value');
    }
    if (_.isEmpty(accessorialsCopy.AccessorialFuel.value)) {
      _.unset(accessorialsCopy, 'AccessorialFuel.value');
    }
    if (_.isEmpty(accessorialsCopy.AccessorialObligate.value)) {
      _.unset(accessorialsCopy, 'AccessorialObligate.value');
    }
    this.groupKeys.Accessorials = accessorialsCopy;
    this.isSaveAvailable = !_.isEqual(this.groupKeys.Accessorials, this.groupKeysCopy.Accessorials);

    if (!this.isSaveAvailable) {
      this.onDataChange()
    }
  }

  onChangeSpotDimensions() {
    const spotDimensionsCopy = angular.copy(this.spotDimensions);
    if (_.isEmpty(spotDimensionsCopy.SpotDimensions.value)) {
      _.unset(spotDimensionsCopy, 'SpotDimensions.value');
    }

    if (!this.spotDimensions.SpotWeight.value) {
      this.spotDimensions.SpotWeight.value = {}
    }

    this.groupKeys.SpotDimensions = spotDimensionsCopy;
    this.isSaveAvailable = !_.isEqual(this.groupKeys.SpotDimensions, this.groupKeysCopy.SpotDimensions);

    if (!this.isSaveAvailable) {
      this.onDataChange()
    }
  }

  onSaveProgram() {

    if (!_.isEmpty(_.get(this.spotDimensions, 'SpotDimensions.value', []))) {
      if ((!_.get(this.spotDimensions, 'SpotDimensions.value.width')) ||
        (!_.get(this.spotDimensions, 'SpotDimensions.value.height')) ||
        (!_.get(this.spotDimensions, 'SpotDimensions.value.length'))) {
        const spotDimensionsCopy = angular.copy(this.spotDimensions);
        _.unset(spotDimensionsCopy, 'SpotDimensions.value');

        this.groupKeys.SpotDimensions = spotDimensionsCopy;
      }
    }


    if (this.groupKeys.Accessorials) {
      this.groupKeysCopy.Accessorials = angular.copy(this.groupKeys.Accessorials);
    }
    if (this.groupKeys.SpotDimensions) {
      this.groupKeysCopy.SpotDimensions = angular.copy(this.groupKeys.SpotDimensions);
    }

    const updatedProgram = this.PricePlanService.generatePreferencesDataPayload(this.program, this.groupKeysCopy);
    this.PricePlanService.saveProgramDataByGroups(this.programId, updatedProgram, this.groups, this.accountId)
      .then((updatedProgram) => {
        this.program = updatedProgram;
        this._initValues();
      })
  }

  onCancelChanges() {
    this._initValues();
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component(
    'pricePlanPricingView', {
      bindings: {
        program: '<',
        groups: '<',
        programId: '<',
        accountId: '<?'
      },
      template: require('./pricing.html').default,
      controller: PricePlanPricingViewCtrl
    }
  );
